module.exports = __webpack_public_path__ + "media/src/images/icon__sad--2-33e191f9218849e99a1ccea90d8bbbb7.png";